import React, { Component } from "react";
import uniqueId         from 'lodash/uniqueId';

export default class YouTubeThumbnail extends Component {

    constructor(props) {
        super(props);

        /*this.state = {
            showModalSimple:  false,
        };*/
    }

    render() {
        var yt_id      = this.props.yt_id;
        var width      = this.props.width;
        var yt_img_src = "https://img.youtube.com/vi/"+yt_id+"/1.jpg";

        return (
            <img src = {yt_img_src} width = {width}/>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/YouTubeThumbnail.js